// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Modal } from "antd";
import { WarningOutlined } from "@ant-design/icons/lib";

const { info } = Modal;

export function showInfo(title: string, onOk?: (reason?: string) => void) {
  info({
    title: title,
    icon: <WarningOutlined />,
    okText: "Ok",
    centered: true,
    onOk: () => {
      onOk && onOk();
    }
  });
}
